/**
 * Gated Links Component.
 */
const GatedLinks = async () => {
	// Get all gated links.
	const protectedDownloadButtons = document.querySelectorAll(
		'.wp-block-dv-protected-download-button, .wp-block-dv-query-loop-item__button--download-pdf, .davita-gated',
	);
	if (!protectedDownloadButtons.length) {
		return;
	}

	// Check if user is authenticated. Wait for the status to be resolved.
	if (window.DAVITA_AUTHENTICATED === 'pending') {
		const gatedLinksInterval = setInterval(() => {
			if (window.DAVITA_AUTHENTICATED !== 'pending') {
				clearInterval(gatedLinksInterval);
				GatedLinks();
			}
		}, 100);
	}

	/**
	 * If user is authenticated, update the href attribute of the gated link.
	 * If user is not authenticated, update the href attribute to include a redirect query parameter.
	 */
	if (window.DAVITA_AUTHENTICATED && window.DAVITA_AUTHENTICATED === 'authenticated') {
		protectedDownloadButtons.forEach((protectedDownloadButton) => {
			const gatedLinkTag = protectedDownloadButton.hasAttribute('data-gated-href')
				? protectedDownloadButton
				: protectedDownloadButton.querySelector('[data-gated-href]');
			if (gatedLinkTag) {
				const gatedLinkSpan = gatedLinkTag.querySelector(
					'.protected-download-button__text',
				);
				gatedLinkTag.setAttribute('href', gatedLinkTag.dataset.gatedHref);
				const { signedInText } = gatedLinkTag.dataset;
				if (signedInText && gatedLinkSpan) {
					gatedLinkSpan.textContent = signedInText;
					gatedLinkTag.removeAttribute('data-gated-href');

					const gatedText = protectedDownloadButton.querySelector('[data-gated-text]');
					if (gatedText) {
						gatedText.remove();
					}
				}
			}
		});
	} else {
		protectedDownloadButtons.forEach((protectedDownloadButton) => {
			const gatedLinkTag = protectedDownloadButton.querySelector('[data-gated-href]');
			if (gatedLinkTag) {
				const linkHref = new URL(gatedLinkTag.href);
				linkHref.searchParams.set('redirect', gatedLinkTag.dataset.gatedHref);
				gatedLinkTag.setAttribute('href', linkHref);
			}
		});
	}
};

export default GatedLinks;
